var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.99935 18.3346c-4.6025 0-8.33333-3.7308-8.33333-8.3333s3.73083-8.33333 8.33333-8.33333c4.60245 0 8.33335 3.73083 8.33335 8.33333s-3.7309 8.3333-8.33335 8.3333zm0-1.6666c1.76815 0 3.46385-.7024 4.71405-1.9527 1.2502-1.2502 1.9526-2.9459 1.9526-4.714 0-1.76811-.7024-3.4638-1.9526-4.71404-1.2502-1.25025-2.9459-1.95262-4.71405-1.95262-1.76811 0-3.4638.70237-4.71405 1.95262-1.25024 1.25024-1.95262 2.94593-1.95262 4.71404 0 1.7681.70238 3.4638 1.95262 4.714 1.25025 1.2503 2.94594 1.9527 4.71405 1.9527zm-.83333-10.83336h1.66668v1.66666h-1.66668zm0 3.33333h1.66668v5.00003h-1.66668z",
    fill: "#0075ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon-information.b9b9da302587971d597dabc668f5657f.svg";
export { ForwardRef as ReactComponent };